import React, { FormEvent, FunctionComponent, PropsWithChildren, ReactElement } from 'react'
import './CheckboxRadio.scss'

export interface OwnProps {
  type?: 'checkbox' | 'radio'
  label?: string
  name?: string
  id?: string
  value?: boolean
  disabled?: boolean
  onChange?: (e: boolean) => void;
  propClassName?: string
}

type Props = PropsWithChildren<OwnProps>

export const CheckboxRadio: FunctionComponent<Props> = ({
  type = 'checkbox',
  label,
  name,
  id,
  value,
  disabled = false,
  onChange,
  propClassName = '',
}: Props): ReactElement => {
  const className = `CheckboxRadio ${type} ${propClassName}`
  const labelComp = label && <span className="CheckboxRadio-label">{label}</span>;

  const handleChange = (event: FormEvent<HTMLInputElement>): void => {
    if (onChange) onChange(event.currentTarget.checked);
  };

  return (
    <label className={className} htmlFor={id}>
      {labelComp}
      <input
        className="CheckboxRadio-input"
        type={type}
        name={name}
        id={id}
        checked={value}
        disabled={disabled}
        onChange={handleChange} />
      <span className="CheckboxRadio-mark" />
    </label>
  );
}

export default CheckboxRadio;
